import React from "react";
import styles from "./style.module.scss";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

const TwoCard = () => {
    const { push } = useRouter();
    const { t } = useTranslation("common");

    return (
        <div className={styles.wrapper}>
            <div className={styles.card}>
                <h2 className={styles.title}>
                    {t("cta.passive_title")}
                </h2>
                <div className={styles.actions}>
                    <button className={styles.btn} onClick={() => push("/auth/register")}>
                        {t("cta.passive_button")}
                        <img src="/static/img/HomePage/Arrow Icon.png" alt="Arrow" className={styles.arrowIcon} />
                    </button>
                </div>
            </div>

            <div className={styles.card}>
                <h2 className={styles.title}>
                    {t("cta.active_title")}
                </h2>
                <div className={styles.actions}>
                    <button className={styles.btn} onClick={() => push("/auth/register")}>
                        {t("cta.active_button")}
                        <img src="/static/img/HomePage/Arrow Icon.png" alt="Arrow" className={styles.arrowIcon} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TwoCard;
